import { RouteKey } from '@store/constants'

import { ProjectType } from '@adUtilities/constants'

import { ApartmentRouteContext, HouseAndLandRouteContext } from '../types'

enum RouteParamKey {
  Block = 'block',
  Level = 'level',
  Precinct = 'precinct',
  Stage = 'stage',
}

const ROUTES_WITH_PARAMS = [
  RouteKey.LEVEL_VIEW,
  RouteKey.BUILDING,
  RouteKey.PRECINCT,
  RouteKey.STAGES,
]

const parseApartmentRouteParams: (
  searchParams: URLSearchParams
) => ApartmentRouteContext = (searchParams) => {
  const block = searchParams.get(RouteParamKey.Block) || ''
  const level = searchParams.get(RouteParamKey.Level) || ''

  return {
    block,
    level,
    projectType: ProjectType.Apartment,
  }
}

const parseHouseAndLandRouteParams: (
  searchParams: URLSearchParams
) => HouseAndLandRouteContext = (searchParams) => {
  const precinct = searchParams.get(RouteParamKey.Precinct) || ''
  const stage = searchParams.get(RouteParamKey.Stage) || ''

  return {
    precinct,
    stage,
    projectType: ProjectType.HouseAndLand,
  }
}

const parseRouteParams: (
  value: string,
  projectType: ProjectType
) => {
  route: string
  context?: ApartmentRouteContext | HouseAndLandRouteContext
  urlParams?: string
} = (value, projectType) => {
  const [route, routeParams] = value.split('?')
  const searchParams = new URLSearchParams(routeParams)

  if (!ROUTES_WITH_PARAMS.includes(route as RouteKey) || !searchParams.size) {
    return {
      route,
    }
  }

  const context =
    projectType === ProjectType.Apartment
      ? parseApartmentRouteParams(searchParams)
      : parseHouseAndLandRouteParams(searchParams)

  return {
    route,
    context,
    urlParams: searchParams.toString(),
  }
}

export default parseRouteParams
